/**
 * @module lib/download
 * @summary Trigger a browser file download from a Blob or text.
 * @ported-from JCC PFD Engineering Tool v1.1.html lines 3743-3744.
 */

/** Download a Blob as `name`. */
export function dlBlob(blob: Blob, name: string): void {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
  // Release the object URL on the next tick.
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}

/** Download text as `name` with the given MIME type. */
export function dlText(txt: string, name: string, type = 'text/plain'): void {
  dlBlob(new Blob([txt], { type }), name);
}
